export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro: string
  bulletsLabel: string
  bullets: string[]
  closingLabel?: string
  closing: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Automotive Troubleshooting Logic Handbook',
    subtitle: 'Symptom → Possible Cause → Test → Result → Next Step',
    intro:
      'Teach students how to think through automotive faults instead of guessing or replacing parts randomly.',
    bulletsLabel: 'Inside:',
    bullets: [
      'Diagnostic reasoning',
      'Root-cause thinking',
      'DTC interpretation',
      'Test-before-replace methodology',
      'Power / ground / signal logic',
      'Known-good comparison',
      'Intermittent faults',
      'Mechanical vs electrical reasoning',
      'Evidence vs assumption',
      'What to test next',
      'Professional troubleshooting habits',
    ],
    closing: 'Stop teaching diagnosis as guessing. Start teaching a process.',
  },
  {
    id: '02',
    title: 'Automotive Common Faults & Symptoms Handbook',
    subtitle: 'What the Vehicle Is Telling You',
    intro: 'A practical instructor reference organized around real vehicle symptoms.',
    bulletsLabel: 'Includes:',
    bullets: [
      'No crank',
      'Crank/no start',
      'Rough idle',
      'Misfire',
      'Hesitation',
      'Poor acceleration',
      'Overheating',
      'Battery discharge',
      'Charging faults',
      'Brake symptoms',
      'Steering problems',
      'Suspension noise',
      'Transmission symptoms',
      'HVAC complaints',
      'Electrical faults',
      'Warning lamps',
      'Communication problems',
      'ABS/ESC symptoms',
      'ADAS warnings',
    ],
    closingLabel: 'Each symptom connects to:',
    closing: 'POSSIBLE SYSTEMS → POSSIBLE CAUSES → WHAT TO CHECK FIRST',
  },
  {
    id: '03',
    title: 'Automotive Systems Quick Reference Handbook',
    subtitle: 'Essential Components, Functions & System Relationships',
    intro:
      'A fast-reference handbook for reviewing major automotive systems before or during lesson preparation.',
    bulletsLabel: 'Includes:',
    bullets: [
      'Engine',
      'Cooling',
      'Lubrication',
      'Fuel',
      'Ignition',
      'Exhaust',
      'Brakes',
      'Steering',
      'Suspension',
      'Electrical',
      'Starting/charging',
      'Drivetrain',
      'HVAC',
      'Diagnostics',
      'Vehicle networks',
      'Hybrid/EV',
      'ADAS',
    ],
    closing: 'Review the system quickly. Walk into class prepared.',
  },
  {
    id: '04',
    title: 'Automotive Instructor Assessment & Question Bank',
    subtitle: 'Knowledge Checks, Diagnostic Scenarios & Answer Keys',
    intro: 'Stop creating every assessment from an empty page.',
    bulletsLabel: 'Inside:',
    bullets: [
      'Multiple-choice questions',
      'True / false',
      'Short-answer questions',
      'Component identification',
      'Cause-and-effect questions',
      'Diagnostic scenarios',
      '“What would you test next?”',
      'Workshop reasoning',
      'Beginner-to-advanced difficulty',
      'Answer keys',
      'Instructor discussion prompts',
    ],
    closing: 'Teach the material. Check understanding. Measure progress.',
  },
  {
    id: '05',
    title: 'Automotive Teaching & Explanation Handbook',
    subtitle: 'How to Explain Complex Automotive Systems Clearly',
    intro:
      'Knowing Automotive Technology does not automatically make difficult systems easy to explain. This handbook helps instructors communicate complex concepts more clearly.',
    bulletsLabel: 'Inside:',
    bullets: [
      'Better technical explanations',
      'Accurate analogies',
      'Electrical fundamentals',
      'Sensors and actuators',
      'OBD-II',
      'Fuel trim',
      'CAN networks',
      'ABS',
      'HVAC',
      'Hybrid/EV',
      'ADAS',
      'Better questioning methods',
      'Student comprehension checks',
      'Common student confusion',
      'Step-by-step explanation methods',
    ],
    closing:
      'Better teaching is not only about knowing more. It is about making difficult concepts easier to understand.',
  },
]
